// ConfirmButton.tsx
import { Button, Typography, Box, TypographyVariant } from '@mui/material';
import CircleRoundedIcon from '@mui/icons-material/CircleRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import { useTranslation } from 'react-i18next';

interface ConfirmButtonProps {
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => Promise<void>;
    title?: string;
    titleVariant?: TypographyVariant;
    additionalStyle?: any;
}

const ConfirmButton: React.FC<ConfirmButtonProps> = ({ onClick, title, titleVariant = 'body1', additionalStyle = {} }) => {
    const { t } = useTranslation();
    return (
        <Button variant="outlined" onClick={onClick}
            sx={{
                padding: '0.5rem',
                maxWidth: '200px',
                width: '100%', // Add this line
                ...additionalStyle
            }}>
            <Typography variant={titleVariant} sx={{ flex: 1 }} noWrap>
                {title || t('invoiceForm.button.text.confirm')}
            </Typography>
            <Box sx={{ position: 'absolute', right: 10, display: 'inline-flex' }}>
                <CircleRoundedIcon fontSize="large" />
                <ArrowForwardIosRoundedIcon fontSize="small" sx={{
                    color: 'var(--white)',
                    position: 'absolute', top: '50%', left: '50%',
                    transform: 'translate(-50%, -50%)'
                }} />
            </Box>
        </Button>
    )
};

export default ConfirmButton;